import { Checkbox, Row, Slider, Tooltip } from 'antd';
import { adjustLocalMinuteToUtc, minutesAsTime, timeAsMinutes } from '../util/dates';
import { CSSProperties, useEffect, useState } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface TimeOfDaySliderProps {
  disabled?: boolean;
  onChange?: (times: [number, number]) => void;
  style?: CSSProperties;
}

const DEFAULT_TIMES: [number, number] = [timeAsMinutes('08:00'), timeAsMinutes('17:00')];

const SLIDER_MARKS: string[] = ['00:00', '06:00', '09:00', '15:00', '18:00'];


/**
 * A component to allow selection of a time of day range. onChange yields start, end times in minutes since 00:00 in UTC
 * @param props
 * @constructor
 */
const TimeOfDaySlider = (props: TimeOfDaySliderProps) => {
  const [timesOfDay, setTimesOfDay] = useState<[number, number]>(DEFAULT_TIMES);
  const [excludeSelected, setExcludeSelected] = useState<boolean>(false);

  useEffect(() => {
    if (props.onChange) {
      const adjustedTimes: [number, number] = timesOfDay
        .sort((a, b) => a - b)
        .map(t => {
          if (t === 1440) return t - 1;
          return t;
        })
        .map(adjustLocalMinuteToUtc) as [number, number];
      if (excludeSelected) adjustedTimes.reverse();

      props.onChange(adjustedTimes);
    }
  }, [timesOfDay, excludeSelected]);

  return (
    <>
      <Row style={{ justifyContent: 'space-between' }}>
        <Row>

          <div className={'input-label'}>Time of day (local)</div>
          <Tooltip title={'Both times are inclusive'}>
            <QuestionCircleOutlined style={{ marginTop: '5px', marginLeft: '6px' }}/>
          </Tooltip>
        </Row>
        <div>
          <Row>
            <Checkbox
              checked={excludeSelected}
              onChange={e => setExcludeSelected(e.target.checked)}
              disabled={props.disabled}
            >Exclude selected</Checkbox>
            <Tooltip title={'Show only data for times that are not selected'} placement={'topLeft'}>
              <QuestionCircleOutlined style={{ marginTop: '5px' }}/>
            </Tooltip>
          </Row>
        </div>
      </Row>
      <Slider
        marks={SLIDER_MARKS.reduce((acc: { [index: number]: string }, curr) => ({
          ...acc,
          [timeAsMinutes(curr)]: curr,
        })
        , {})
        }
        range={true}
        disabled={props.disabled}
        defaultValue={timesOfDay}
        step={15}
        min={0}
        max={24 * 60}
        tipFormatter={m => m !== undefined && minutesAsTime(m)}
        onAfterChange={setTimesOfDay}
        // onChange={setTimesOfDay}
        style={props.style}
        trackStyle={(excludeSelected && [{ backgroundColor: 'red' }]) || undefined}
      />
    </>
  );
};

export default TimeOfDaySlider;
